<template src="./Devedor.html"></template>

<script>

import { mapMutations } from "vuex";  
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import store from "../store";
import usuario from "@/services/usuario";
import devedoresCtrl from "@/services/devedores";

export default {
  name: 'Home',
  mixins: [validationMixin],
  data () {
    return {
      msg: 'Home',
      email: '',
      password: '',
      tipo: 'cpf',
      cpf: '',
      cnpj: '',
      telefone: '',
      mensagem: '',
      maskCPF: '###.###.###-##',
      maskCNPJ: '##.###.###/####-##',
      maskTelefone: '(##) #####-####',
      cards: {
        card1: "",
        card2: "",
        card3: ""
      },
      devedor: {}
    }
  },
  methods: {
    entrar () {
      this.$router.push('/');
    },
    async submit () {

      try {
        if (this.$refs.form.validate()) {
          this.$v.$touch() 
          if (this.tipo == 'cpf' && !this.cpf) {
            this.setError('CPF deve ser informado!');
            return;
          }
          if (this.tipo == 'cnpj' && !this.cnpj) {
            this.setError('CNPJ deve ser informado!');
            return;
          }
          if (!this.devedor && !this.devedor._id) {
            this.setError('Você não tem dividas cadastradas!');
            return;
          }
          if (!this.email) {
            this.setError('Email não informado!');
            return;
          }
          if (!this.password) {
            this.setError('Senha não informada!');
            return;
          }

          this.model = {
            name: this.devedor.Nome,
            username: this.email, 
            senha: this.password, 
            devedor: this.devedor._id,
            acesso: "Devedor",
            grand: "Devedor"
          }

          let res = await usuario.saveUsuarioDevedor(this.model);
          

          await this.$store.dispatch('signUserIn', {username: this.email, password: this.password})
          res = await usuario.getUsuario(store.getters.user._id);
          if (res.grand == "Devedor") {
            await this.$router.push('/minhas-dividas');
          } else {
            await this.$router.push('/minhas-dividas');
          }
        }
      } catch (e) {
        this.setError(e);
      }
      
    },
    async getSearch (search) {
      if (search) {
        
        this.setLoading(true);
        this.devedor = {};
        let devedores = await devedoresCtrl.getSearchCPF(search);
        if (devedores.length == 1) {
          this.devedor = await devedoresCtrl.getDevedoreIdDev(devedores[0]._id);
        } else {
          this.mensagem = "Ops! " + this.tipo.toUpperCase() + " não localizado! Não localizamos o seu CPF/CNPJ em nossa base, entre em contato através dos nossos canais de atendimento para mais informações.";
        }
        this.setLoading(false);
      }
    },
    ...mapMutations({
      setLoading : "setLoading",
      setError: "setError"
    })
  }, 
  watch: {
    user (value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required, email },
    password: { required }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Deve ser um e-mail válido')
      !this.$v.email.required && errors.push('Usuário deve ser informado')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Senha deve ser informada')
      return errors
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html {
    font-family: Arial !important;
  }
  v-input {
    font-family: Arial !important;
  }
  .input-login {
    padding: 10px;
  }

  h1 {
    font-size: 40px !important;
    font-weight: 400;
  }
  h2 {
    font-weight: 400;
  }

  .v-card-title {
    font-weight: 600 !important;
    font-size: 35px !important;
  }

  .hr-title {
    border: none;
    border-top: 6px solid white;
    width: 150px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .como-funciona {
    line-height: 0.5;
    text-align: center;
    font-weight: 400;
  }
  .como-funciona span {
    display: inline-block;
    position: relative;  
  }
  .como-funciona span:before,
  .como-funciona span:after {
    content: "";
    position: absolute;
    height: 5px;
    margin-top: 12px;
    border-bottom: 6px solid #00a99d;
    top: 0;
    width: 250px;
  }
  .como-funciona span:before {
    right: 100%;
    margin-right: 15%;
  }
  .como-funciona span:after {
    left: 100%;
    margin-left: 15%;
  }
  .login {
    margin-top: 60px;
  }
  .diarioobra {
    font-size: 40px !important;
    font-weight: 600;
    font-style: normal;
    
    margin-bottom: 20px !important;
  }
  .diario {
    color: #2088b4;
  }
  .text-login {
    font-size: 24px !important;
    font-weight: 600;
    padding: 10px 10px 30px 10px;
  }
  .text-info {
    font-size: 12px !important;
    font-weight: 400;
    padding: 0px 10px 20px 10px;
  }
  .icon-input {
    margin-top: 4px;
    background-color: #2088b4;
    width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Devedor.vue